import React, { useEffect } from 'react'
import MyComponent from '../MyComponent'
import shortid from "shortid";


const FormPlugin = ({ containerObject, templateName, contentId, dataZone }) => {
console.log("FormTemplatePlugin---------Form------",containerObject,contentId)
    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId}
            data-template-name={templateName} className="vast-plugin-content row gx-0">
            {containerObject && containerObject.form ?
                 <MyComponent type={containerObject.form['@type']} key={shortid.generate()} containerObject={containerObject.form}
                     contentId={contentId} dataZone={dataZone} templateName={containerObject.form['@type']} />
                :
            ""}
        </div>
    )

}
export default FormPlugin